import React, { useReducer } from 'react';
import axios from 'axios';
//import uuid from 'uuid';
import UserContext from './userContext';
import userReducer from './userReducer';
import {
  GET_USERS,
  CLEAR_USERS,
  ADD_USER,
  DELETE_USER,
  SET_CURRENT,
  CLEAR_CURRENT,
  UPDATE_USER,
  FILTER_USERS,
  CLEAR_FILTER,
  USER_ERROR
} from '../types';

const UserState = props => {
  const initialState = {
    users: null,
    current: null,
    filtered: null,
    error: null
  };

  const [state, dispatch] = useReducer(userReducer, initialState);

  // Get Users
  const getUsers = async () => {
    try {
      const res = await axios.get('/api/v1/users');
      dispatch({
        type: GET_USERS,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: USER_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Add User
  const addUser = async user => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    try {
      const res = await axios.post('/api/v1/users', user, config);
      dispatch({
        type: ADD_USER,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: USER_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Delete User
  const deleteUser = async id => {
    try {
      await axios.delete(`/api/v1/users/${id}`);
      dispatch({
        type: DELETE_USER,
        payload: id
      });
    } catch (err) {
      dispatch({
        type: USER_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Update User
  const updateUser = async user => {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    console.log('userStateUpdateUser', user);
    try {
      const res = await axios.put(`/api/v1/users/${user.id}`, user, config);

      dispatch({
        type: UPDATE_USER,
        payload: res.data
      });
    } catch (err) {
      dispatch({
        type: USER_ERROR,
        payload: err.response.msg
      });
    }
  };

  //Clear Users
  const clearUsers = () => {
    dispatch({ type: CLEAR_USERS });
  };

  //Set Current User
  const setCurrent = user => {
    dispatch({ type: SET_CURRENT, payload: user });
  };

  //Clear Current User

  const clearCurrent = () => {
    dispatch({ type: CLEAR_CURRENT });
  };

  //Filter Users
  const filterUsers = text => {
    dispatch({ type: FILTER_USERS, payload: text });
  };

  //Clear Filter
  const clearFilter = () => {
    dispatch({ type: CLEAR_FILTER });
  };

  return (
    <UserContext.Provider
      value={{
        users: state.users,
        current: state.current,
        filtered: state.filtered,
        error: state.error,
        getUsers,
        addUser,
        deleteUser,
        setCurrent,
        clearCurrent,
        updateUser,
        filterUsers,
        clearFilter,
        clearUsers
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
